import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import {Button} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import Box from "@mui/material/Box";
import {config} from "../../../constant";
import {joinWithLastWord} from "../../../utils/formatString";

export default function DialogRecordsByCategoriesStats({open, onClose}) {
    const [archiveCategoriesRecords, setArchiveCategoriesRecords] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        fetch(`${config.BASE_URL}/archive-categories/stat-records`)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`${response.status} ${response.statusText}`)
                }
                return response.json();
            })
            .then(data => {
                setArchiveCategoriesRecords(data);
            })
            .catch((error) => {
                const message = 'Erreur dans la récupération des records par catégories';
                console.error(message, error);
                navigate("/error", {state: {message: message}});
            });
    }, []);

    return (
        archiveCategoriesRecords && (
            <Dialog open={open} onClose={onClose} maxWidth={'sm'} fullWidth>
                <DialogTitle>Records par catégorie</DialogTitle>
                <DialogContent>
                    {archiveCategoriesRecords.map(archiveCategoryRecord => (
                        <Box key={archiveCategoryRecord.name} sx={{mb: 2}}>
                            {archiveCategoryRecord.name} : {joinWithLastWord(archiveCategoryRecord.recordHolders.map(person => person.firstName), ', ', 'et')} ({archiveCategoryRecord.record} victoire{archiveCategoryRecord.record.length > 1 && 's'})
                        </Box>
                    ))}
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>OK</Button>
                </DialogActions>
            </Dialog>
        )
    );
}
